import React, { Component } from 'react'
import { Form, Layout, Input, Button, Card } from 'antd'
import { gql, graphql, compose } from 'react-apollo'
import Thank from './Component/Thank'
import './style.css'

const { Item } = Form
const { Content } = Layout

class Submission extends Component {
    constructor(props){
        super(props)
        this.state = {
            isFinish: false
        }
    }
    handleOk = () => {
        let { event } = this.props
        this.props.form.validateFields((err, value) => {
            if(!err) {
                this.props.createToken ({
                    variables: {
                        bib: value.bib,
                        slug: event.slug,
                        userId: value.pageId,
                        accessToken: this.props.facebook.accessToken,
                        name: value.pageName
                    }
                }).then(() => {
                    this.setState({
                        isFinish: true,
                    })
                })
            }
        })
    }
    
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, value) => {
            if(!err) {
                console.log('value', value)
                this.handleOk()
            }
        })

    }

    render () {
        if(this.state.isFinish) {
            return <Thank />
        }
        const { getFieldDecorator } = this.props.form
        return (
            <Layout style={{background: "#ffffff"}}>
                <Content className="wrap-form">
                    <Card>
                        <Form className="form" onSubmit={this.handleSubmit}>
                            <Item>
                                {getFieldDecorator('bib', {
                                    rules: [{ required: true, message: 'Please input you bib'}]
                                })(
                                    <Input placeholder="bib number" style={{width: "200px"}} />
                                )}
                            </Item>
                            <Item>
                                {getFieldDecorator('pageId', {
                                    rules: [{ required: true, message: 'Please input id of page'}]
                                })(
                                    <Input placeholder="id of page" style={{width: "200px"}} />
                                )}
                            </Item>
                            <Item>
                                {getFieldDecorator('pageName', {
                                    rules: [{ required: true, message: 'Please input name of page'}]
                                })(
                                    <Input placeholder="name of page" style={{width: "200px"}} />
                                )}
                            </Item>
                            <Item>
                                <Button type="primary" htmlType="submit"> Confirm</Button>
                            </Item>
                        </Form>
                    </Card>
                </Content>
            </Layout>
        )
    }
}

const createAccessToken = gql`
mutation createToken($bib: Int!, $slug: String!, $userId: String!, $accessToken: String!, $name: String!){
  facebook(
    recode: {
        bib: $bib,
        slug:$slug
        userId: $userId
        accessToken: $accessToken
        name: $name
        isPage: true
    }
  ){
        bib
        slug
        name
        userId
        accessToken
  }
}
`
export default compose(
    Form.create(),
    graphql(createAccessToken, {
        name: 'createToken'
    })
)(Submission)


// WEBPACK FOOTER //
// ./src/Page/Submission.js